import { Navigate, useLocation } from "react-router-dom";
import styled from "styled-components/macro";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { CssBaseline, useMediaQuery } from "@mui/material";
import React, { useState, useEffect, Fragment } from "react";

import PerfectScrollBar from "react-perfect-scrollbar";
import pages from "../constants/pages";
import GlobalStyle from "../components/GlobalStyle";
import Navbar from "./dashboard layout components/Navbar";
import { signInMember } from "../redux/slices/memberSlice";
import Sidebar from "./dashboard layout components/Sidebar";
import MainContent from "./dashboard layout components/MainContent";
import WebsiteLoader from "./dashboard layout components/WebsiteLoader";
import Footer from "./dashboard layout components/Footer";
import { renderUserInterface } from "../redux/slices/renderUISlice";
import GradientNavbar from "./dashboard layout components/navbar components/GradientNavbar";

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const ScrollBar = styled(PerfectScrollBar)`
  // height: calc(100% - 8px) !important;
  display: flex;

  > * {
    flex: 1;
  }
`;

const ContentWrapper = styled.div`
  overflow: auto;
`;

const MainContentWrapper = styled.div`
  flex: 1;
  margin: 4px;
  overflow: auto;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
`;

export default function DashboardLayout() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();

  const [sidebarState, setSidebarState] = useState({
    static: true,
    open: true,
  });
  const { authToken, steps, parentBrandVerified, isAdminVerified, role } =
    useSelector((state) => state.memberDetails);

  const isLaptop = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });

  const userID = parseInt(sessionStorage.getItem("userID"));
  const sessionStorageToken = sessionStorage.getItem("authToken");
  const businessEntityId = sessionStorage.getItem("businessEntityId");
  const [selectedMenu, setSelectedMenu] = useState(location.pathname);

  useEffect(() => {
    dispatch(renderUserInterface());
    if (!authToken && sessionStorageToken) {
      dispatch(
        signInMember({
          authToken: sessionStorageToken,
          userID: userID,
          businessEntityId: businessEntityId,
        })
      );
    }
  }, [authToken, sessionStorageToken, userID, businessEntityId, dispatch]);

  if (!(authToken || sessionStorageToken)) {
    return (
      <Navigate
        to={`${pages.signIn.route}`}
        state={{ from: location.pathname }}
      />
    );
  }

  if (!authToken && sessionStorageToken) {
    return (
      <Fragment>
        <CssBaseline />
        <GlobalStyle />

        <WebsiteLoader />
      </Fragment>
    );
  }

  if (role === "NORMAL_USER" && (!steps?.step2 || !steps?.step3)) {
    return <Navigate to={`${pages.createWelcomePage.route}`} />;
  }

  if (role === "NORMAL_USER" && parentBrandVerified === 0) {
    return <Navigate to={`${pages.createWelcomePage.route}`} />;
  }

  if (role === "NORMAL_USER" && !isAdminVerified) {
    return <Navigate to={`${pages.createWelcomePage.route}`} />;
  }

  return (
    <Fragment>
      <CssBaseline />
      <GlobalStyle />

      <ScrollBar>
        <div
          id="scrollable-container"
          style={{ height: "100vh", overflowY: "auto" }}
        >
          <MainWrapper>
            <div style={{ position: "sticky", top: 0, zIndex: 999 }}>
              <Navbar
                sidebarState={sidebarState}
                toggleSideBar={toggleSidebarState}
                setSelectedMenu={setSelectedMenu}
              />
              <GradientNavbar />
            </div>

            <ContentWrapper>
              <div
                style={{
                  display: "flex",
                  flex: "1",
                  alignItems: "stretch",
                }}
              >
                <Sidebar
                  sidebarState={sidebarState}
                  onMouseEnter={mouseEnterSidebar}
                  onMouseLeave={mouseLeaveSidebar}
                  selectedMenu={selectedMenu}
                  setSelectedMenu={setSelectedMenu}
                />

                <MainContentWrapper>
                  <MainContent />
                </MainContentWrapper>
              </div>

              <Footer />
            </ContentWrapper>
          </MainWrapper>
        </div>
      </ScrollBar>
    </Fragment>
  );

  function toggleSidebarState() {
    setSidebarState((prevValue) => ({
      static: !prevValue.static,
      open: !prevValue.open,
    }));
  }

  function mouseEnterSidebar() {
    if (isLaptop && !sidebarState.static) {
      setSidebarState((prevValue) => ({
        ...prevValue,
        open: true,
      }));
    }
  }

  function mouseLeaveSidebar() {
    if (isLaptop && !sidebarState.static) {
      setSidebarState((prevValue) => ({
        ...prevValue,
        open: false,
      }));
    }
  }
}
